import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { Col, Nav, Row } from 'react-bootstrap'

// import CompareStatsAccordion from '@shared/components/player/compareStatsAccodion'
import { preparePlayerStats } from '@shared/libs/player-comparison'
import navStyles from '@shared-components/commonNav/style.module.scss'
import CompareList from '../compareList'
import useTranslation from 'next-translate/useTranslation'
import CustomSelect from '@shared/components/customSelect'
import { getMatchFormat } from '@shared/libs/match-format'

function ComparePlayerStats({ firstPlayer, secondPlayer }) {
  const { t } = useTranslation()
  const [selectedTab, setSelectedTab] = useState('oBatting')
  const selectedFormate = useRef()
  const [playerStats, setPlayerStats] = useState(preparePlayerStats(firstPlayer?.oStats, secondPlayer?.oStats, selectedFormate.current))

  const format = makeFormatOfPlayer(firstPlayer?.oStats, secondPlayer?.oStats)

  useEffect(() => {
    if (format?.length && !selectedFormate.current) {
      handleFormat({ p1Format: format[0], p2Format: format[0] })
    }
  }, [format])

  useEffect(() => {
    if (selectedFormate.current) {
      handleFormat(selectedFormate.current)
    } else if (format?.length && !selectedFormate.current) {
      handleFormat({ p1Format: format[0], p2Format: format[0] })
    }
  }, [firstPlayer, secondPlayer])

  function makeFormatOfPlayer(p1 = [], p2 = []) {
    const format = []
    new Map([...p1, ...p2].map(item => [item?.nPriority, item]).sort()).forEach((e, i) => {
      format.push({
        sTitle: getMatchFormat(e?.sMatchStatsTypes)?.toUpperCase(),
        sValue: String((i + 1)),
        sMatchStatsTypes: e?.sMatchStatsTypes
      })
    })
    return format
  }

  function handleFormat(f) {
    selectedFormate.current = f
    setPlayerStats(preparePlayerStats(firstPlayer?.oStats, secondPlayer?.oStats, f))
  }

  return (
    <>
      {format?.length > 0 && (
        <Row className='mb-3 justify-content-between'>
          <Col xs={5} sm={3} md={2}>
            <CustomSelect
              options={format}
              defaultSelected
              placeholder="Select Format"
              labelKey="sTitle"
              valueKey="sValue"
              isNative
              onChange={(e) => {
                handleFormat({ ...selectedFormate.current, p1Format: e })
              }}
            />
          </Col>
          {secondPlayer?._id && (
            <Col xs={5} sm={3} md={2}>
              <CustomSelect
                options={format}
                defaultSelected
                placeholder="Select Format"
                labelKey="sTitle"
                valueKey="sValue"
                isNative
                onChange={(e) => {
                  handleFormat({ ...selectedFormate.current, p2Format: e })
                }}
              />
            </Col>
          )}
        </Row>
      )}
      <Nav className={`${navStyles.commonNav} text-uppercase equal-width-nav mb-2 mb-md-3`} variant="pills">
        <Nav.Item className={navStyles.item}>
          <a className={`${selectedTab === 'oBatting' && navStyles.active} nav-link`} onClick={() => setSelectedTab('oBatting')}>
            {t('common:Batting')}
          </a>
        </Nav.Item>
        <Nav.Item className={navStyles.item}>
          <a className={`${selectedTab === 'oBowling' && navStyles.active} nav-link`} onClick={() => setSelectedTab('oBowling')}>
            {t('common:Bowling')}
          </a>
        </Nav.Item>
      </Nav>
      <CompareList data={playerStats?.[selectedTab]} isColored />
    </>
  )
}
ComparePlayerStats.propTypes = {
  firstPlayer: PropTypes.object,
  secondPlayer: PropTypes.object
}
export default ComparePlayerStats
